import React from "react";
import { Box, Typography, Button, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";

const Admin = () => {
  return (
    <Box mx={6}>
      {/* Header */}
      <Grid container justifyContent="center" style={{ marginBottom: "16px" }}>
        <Typography variant="h4">管理ページ</Typography>
      </Grid>

      {/* Navigation Buttons */}
      <Grid container spacing={2} direction="column" alignItems="flex-start">
        <Grid item>
          <Button
          style={{ fontSize: "20px" }}
            variant="contained"
            color="primary"
            component={Link}
            to="/admin/selling"
          >
            売上推移
          </Button>
        </Grid>
        <Grid item>
          <Button
          style={{ fontSize: "20px" }}
            variant="contained"
            color="primary"
            component={Link}
            to="/admin/products"
          >
            商品一覧
          </Button>
        </Grid>
        <Grid item>
          <Button
          style={{ fontSize: "20px" }}
            variant="contained"
            color="primary"
            component={Link}
            to="/admin/users"
          >
            ユーザー一覧
          </Button>
        </Grid>
        <Grid item>
          <Button
          style={{ fontSize: "20px" }}
            variant="contained"
            color="primary"
            component={Link}
            to="/admin/contacts"
          >
            SORAへのお問い合わせ一覧
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Admin;